import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuthStore } from './stores/authStore';
import { useEffect } from 'react';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import LoginPage from './pages/auth/Login';
import RegisterPage from './pages/auth/Register';
import DashboardPage from './pages/Dashboard';
import LearningPage from './pages/learning/LearningHub';
import MentorPage from './pages/mentor/AIMentor';
import ProjectsPage from './pages/projects/ProjectsShowcase';
import PublicProjectsPage from './pages/projects/PublicProjectsShowcase';
import ProjectDetailPage from './pages/projects/ProjectDetail';
import MentorshipPage from './pages/mentorship/MentorshipHub';
import AnalyticsPage from './pages/analytics/AnalyticsDashboard';
import ProfilePage from './pages/profile/ProfilePage';
import NotFoundPage from './pages/NotFound';
import ComingSoonPage from './pages/ComingSoon';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import TermsOfServicePage from './pages/TermsOfService';
import DonatePage from './pages/DonatePage';
import DonateThankYouPage from './pages/DonateThankYou';
import LoadingSpinner from './components/ui/LoadingSpinner';

function App() {
  const { user, loading, checkAuth } = useAuthStore();

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-secondary-50">
        <LoadingSpinner size="lg" />
      </div>
    );
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route
        path="/login"
        element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />}
      />
      <Route 
        path="/register" 
        element={user ? <Navigate to="/dashboard" replace /> : <RegisterPage />} 
      />

      {/* Legal & donation routes */}
      <Route path="/terms" element={<TermsOfServicePage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="/donate" element={<DonatePage />} />
      <Route path="/donate/thanks" element={<DonateThankYouPage />} />

      {/* Public project showcase */}
      <Route path="/projects" element={<PublicProjectsPage />} />
      <Route path="/projects/:slug" element={<ProjectDetailPage />} />

      {/* Protected routes */}
      <Route 
        path="/*" 
        element={
          user ? (
            <Layout>
              <Routes>
                <Route path="/dashboard" element={<DashboardPage />} />
                
                {/* Learning routes */}
                <Route path="/learning" element={<LearningPage />} />
                
                {/* AI Mentor routes */}
                <Route path="/mentor" element={<MentorPage />} />
                
                {/* Projects routes */}
                <Route path="/my-projects" element={<ProjectsPage />} />
                
                {/* Mentorship routes */}
                <Route path="/mentorship" element={<MentorshipPage />} />
                
                {/* Analytics routes */}
                <Route path="/analytics" element={<AnalyticsPage />} />
                
                {/* Profile routes */}
                <Route path="/profile" element={<ProfilePage />} />
                
                {/* Catch all for authenticated users */}
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Layout>
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
    </Routes>
  );
}

export default App;